import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { environment } from 'src/environments/environment';
import { groupApprovalIntarface } from '../approvers-group.component';

@Injectable({
	providedIn: 'root',
})
export class ApproversGroupService {
	private getApproversGroupUrl = environment.baseApiUrl + 'register/customer/approversGroup';
	private getAllSolutionAreasUrl = environment.baseApiUrl + 'register/customer/solutionAreas';
	private getAllCustomersUrl = environment.baseApiUrl + 'register/customer/approversGroupCustomers';
	private getAnalystsApproversUrl = environment.baseApiUrl + 'register/customer/analystsApprovers';
	private putAnalystsApproversGroupUrl = environment.baseApiUrl + 'register/customer/updateAnalystsApprovers';
	private getGroupApprovalURL = environment.baseApiUrl + 'register/groupApproval';
	private postGroupApprovalURL = environment.baseApiUrl + 'register/groupApproval';
	private putGroupApprovalURL = environment.baseApiUrl + 'register/groupApproval/{id}';
	private getAllGroupApprovalsURL = environment.baseApiUrl + 'register/groupApproval/{id}';

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getAllSolutionAreas(idApproverGroup: string, customersList: string[]): Observable<genericFormInterface[]> {
		const getAllSolutionAreasUrl = `${this.getAllSolutionAreasUrl}?idApproverGroup=${idApproverGroup}&&customersList=${customersList}`;
		return this.http.get<genericFormInterface[]>(getAllSolutionAreasUrl, { headers: this.headers });
	}

	getApproversGroup(): Observable<iacOptionInterface[]> {
		return this.http.get<iacOptionInterface[]>(this.getApproversGroupUrl, { headers: this.headers });
	}

	getAllCustomers(idApproverGroup: string): Observable<genericFormInterface[]> {
		const getAllCustomersUrl = `${this.getAllCustomersUrl}?idApproverGroup=${idApproverGroup}`;
		return this.http.get<genericFormInterface[]>(getAllCustomersUrl, { headers: this.headers });
	}

	getAnalystsApprovers(
		idApproverGroup: string,
		customersList: string[],
		solutionAreasList: string[]
	): Observable<genericFormInterface[]> {
		const getAnalystsApproversUrl = `${this.getAnalystsApproversUrl}?idApproverGroup=${idApproverGroup}&&customersList=${customersList}&&solutionAreasList=${solutionAreasList}`;
		return this.http.get<genericFormInterface[]>(getAnalystsApproversUrl, { headers: this.headers });
	}

	putTaskApprover(
		idApproverGroup: string,
		approverList: string[],
		solutionAreaList: string[],
		customers: string[],
		conector: string
	): Observable<any> {
		const putAnalystsApproversGroupUrl = `${this.putAnalystsApproversGroupUrl}?idApproverGroup=${idApproverGroup}`;

		const body = {
			email: approverList,
			solutionArea: solutionAreaList,
			customer: customers,
			conector: conector,
		};

		return this.http.put<JSON>(putAnalystsApproversGroupUrl, body, { headers: this.headers });
	}

	postGroupApproval(data: groupApprovalIntarface): Observable<any> {
		const body = {
			group: data.group,
			conector: data.conector,
		};

		return this.http.post(this.postGroupApprovalURL, body, { headers: this.headers });
	}

	putGroupApproval(data: groupApprovalIntarface): Observable<any> {
		const putStatusCiType = this.putGroupApprovalURL.replace('{id}', data.id.toString());
		const body = {
			group: data.group,
			conector: data.conector,
		};

		return this.http.put(putStatusCiType, body, { headers: this.headers });
	}

	getGroupApproval(): Observable<groupApprovalIntarface[]> {
		return this.http.get<any[]>(this.getGroupApprovalURL, { headers: this.headers });
	}

	getAllGroupApprovals(id: string): Observable<groupApprovalIntarface[]> {
		const getAllGroupApprovalsURL = this.getAllGroupApprovalsURL.replace('{id}', id);
		return this.http.get<any[]>(getAllGroupApprovalsURL, { headers: this.headers });
	}
}
